import { useQuery } from 'react-query';
import { slackStatusApi } from '../../api';

export function useCheckSlackStatus(slackv2Enabled: boolean) {
  const query = useQuery(['slack_status'], () => slackStatusApi({ slackv2Enabled }), {
    enabled: slackv2Enabled,
  });
  return query;
}
